import { PatientBillOfRightsTemplate, MainLayout } from "@/design-system/Templates";
import Header from "@/design-system/Organisms/Header";
import { headerConfig } from "@/design-system/Organisms/Header/Header.config";
import { Footer } from "@/design-system/Organisms";

const PatientBillOfRightsPage = () => (
  <MainLayout
    header={<Header {...headerConfig} />}
    sidebar={null}
    className=""
    footer={<Footer />}
  >
    <PatientBillOfRightsTemplate />
  </MainLayout>
);

export default PatientBillOfRightsPage;
